import { avatarSrc as absoluteAvatarSrc, createApiClient } from '@shared/api-client/index';

// The api origin (no version): each operation path carries its own /v1 prefix.
export const apiOrigin = import.meta.env.VITE_API_URL ?? 'http://localhost:3000';

export const api = createApiClient(apiOrigin);

// Resolve a DTO `avatarUrl` to an absolute `<img>` src on this app's api origin.
export const avatarSrc = (avatarUrl: string | null | undefined) =>
	absoluteAvatarSrc(apiOrigin, avatarUrl);
